import { Suspense, useEffect, lazy } from "react";
import {
  tokenManager,
  checkOauthToken,
} from "coral-utility";

import { useDispatch, useSelector } from "react-redux";
import Landing from "components/Landing/Landing";
import { isAuthenticated } from "state/ducks/connect/selectors";

const Gateway = lazy(() => import("view/connect/Gateway"));

const Connect = () => {
  const dispatch = useDispatch();
  const authenticated = useSelector(isAuthenticated);

  /**
   * (1) User has Token?
   *    1. Verify Token
   *        1. isValid?
   *           - Load into the app
   *        2. isNotValid?
   *           - Direct to landing page for sign-in.
   * (2) User does not have Token?
   *    1. - Direct to landing page for sign-in.
   */
  useEffect(() => {
    if (tokenManager.hasToken()) {
      // call user verify action
      dispatch(checkOauthToken());
    }
  }, [dispatch]);

  /**
   * (1) Checks for Authentication
   * (2)(Loads Landing Page)
   * (3)(Only renders app when we are fully authenticated)
   */
  /* eslint-disable */
  if (tokenManager.hasToken() || authenticated) {
    return (
      <Suspense fallback={null}>
        <Gateway />
      </Suspense>
    );
  }

  return <Landing />;
};

export default Connect;
